<div #container class="nc-threads-canvas-container" [style.background-color]="ncBgColor"></div>
<div class="nc-content-wrapper">
  <ng-content></ng-content>
</div>